import React, { useEffect, useState } from "react";
import { useQueryClient } from "react-query";
import {
  useChangeStatusProduct,
  useGetAllBrands,
  useGetProductList,
} from "../../../../hooks/useContent";
import { Container } from "../../../../theme/GlobalStyle";
import { separate } from "../../../../utils/separate";
import Button from "../../../Button/Button";
import { InputField1 } from "../../../InputField1/InputField1";
import Loading from "../../../Loadings/LoadingTable";
import { SimpleSelect1 } from "../../../SimpleSelect/SimpleSelect1";
import Typography from "../../../Typography/Typography";
import { Card, CardList, Img, Row, Wrapper } from "./changeProductStyle";
import { Spinner } from "reactstrap";
import BreadCrumb from "../../../BreadCrumb/BreadCrumb";

const ChangeProductStatus = () => {
  const basePhotos = "https://apicrm.seyedkala.com/thumbnail/Product";
  const [PageNumber, setPageNumber] = useState(1);
  const [brand, setBrand] = useState("");
  const [name, setName] = useState("");
  const [code, setCode] = useState("");
  const [selected, setSelected] = useState("");

  const {
    data: listPorduct,
    isLoading: loadingProduct,
    hasNextPage,
    fetchNextPage,
    refetch,
  } = useGetProductList(
    PageNumber,
    {
      status: "Active",
      name,
      code,
      brand,
    },
    brand,
    name,
    code
  );

  const {
    mutateAsync,
    isLoading: loadingChangeStatus,
    data: statusChange,
  } = useChangeStatusProduct();

  const handleClick = async (IdProducts) => {
    setSelected(IdProducts);
    await mutateAsync(IdProducts);
  };

  // get all brands
  const { data: listBrands } = useGetAllBrands();

  const brands = listBrands?.data?.brands;
  const res = brands?.map((item) => ({
    label: item.NameBrands,
    value: item?.IdBrands,
  }));

  useEffect(() => {
    let fetching = false;
    const onScroll = async (event) => {
      const { scrollHeight, scrollTop, clientHeight } =
        event.target.scrollingElement;
      if (!fetching && scrollHeight - scrollTop <= clientHeight * 2.5) {
        fetching = true;
        if (hasNextPage) await fetchNextPage();
        fetching = false;
      }
    };
    document.addEventListener("scroll", onScroll);
    return () => {
      document.removeEventListener("scroll", onScroll);
    };
  }, [fetchNextPage, hasNextPage]);

  let i = 0;

  return (
    <>
      <BreadCrumb
        margin="mt-3"
        num1="واحد محتوا"
        num2="محصولات"
        num3="تغییر وضعیت محصول"
        href1="/dashboard/content-controller"
        href2="/dashboard/content-controller/products"
      />
      <Container>
        <div className="row p-3">
          <div className="col-4 ml-3">
            <InputField1
              className="input-control"
              label="نام محصول"
              placeholder="جستحو"
              onChange={(event) => setName(event.target.value)}
            />
          </div>
          <div className="col-4  ml-3">
            <InputField1
              className="input-control"
              label="کد محصول"
              placeholder="جستحو"
              onChange={(event) => setCode(event.target.value)}
            />
          </div>
          <div className="col-4">
            <SimpleSelect1
              label="برند"
              res={res}
              onChange={(event) => setBrand(event.value)}
            />
          </div>
        </div>
        <CardList>
          {loadingProduct ? (
            <Loading />
          ) : (
            listPorduct?.pages?.map((page) =>
              page?.data?.Products?.map((product) => {
                return (
                  <Card key={product?.IdProducts}>
                    <Img src={`${basePhotos}/${product?.PhotoProducts}`} />
                    <Wrapper>
                      <Typography size="14px" weight="bold">
                        {product?.NameProducts}
                      </Typography>
                      <Typography size="14px" weight="bold">
                        {product?.CodeProducts}
                      </Typography>
                    </Wrapper>
                    <Typography align="center">
                      {separate(product?.PriceProducts)} تومان
                    </Typography>
                    <Button
                      size="14px"
                      bgColor={
                        product?.InventoryStatus === "موجود در انبار"
                          ? "#28A745"
                          : "#DC3545"
                      }
                      color="#fff"
                      onclick={() => handleClick(product?.IdProducts)}
                    >
                      {loadingChangeStatus &&
                      product?.IdProducts === selected ? (
                        <Spinner
                          animation="border"
                          color="light"
                          variant="light"
                        />
                      ) : (
                        // product?.InventoryStatus
                        <>
                          {product?.IdProducts === selected &&
                          statusChange?.data?.Status
                            ? statusChange?.data?.Status
                            : product?.InventoryStatus}
                        </>
                      )}
                    </Button>
                  </Card>
                );
              })
            )
          )}
        </CardList>
      </Container>
    </>
  );
};

export default ChangeProductStatus;
